// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
    },
    reducers: {
        updated(state, action) {
            return {
                ...state,
                user: { ...state.user, ...action.payload.user },
            };
        },
    },
});

export const { updated } = authSlice.actions;

export default authSlice;
